import { FaArrowLeft, FaCarSide } from "react-icons/fa";
import styles from "./CarHero.module.css";

const CarHero = ({
  title,
  description,
  onBack,
}) => {

  return (

    <header className={styles.hero}>

      <div className={styles.topRow}>

        <div className={styles.titleBox}>

          <div className={styles.icon}>
            <FaCarSide />
          </div>

          <h1>
            {title}
          </h1>

        </div>

        <button
          type="button"
          onClick={onBack}
          className={styles.backBtn}
          aria-label="بازگشت"
        >
          <FaArrowLeft />
        </button>

      </div>

      <p className={styles.description}>
        {description}
      </p>

    </header>

  );

};

export default CarHero;